<div class="contact-page-wrapper py-5 px-3 animate-fadein">
  <div class="container pb-5">
    
    <!-- Hero Header -->
    <div class="text-center mb-5 py-4">
      <span class="pill-tag gold mb-3">Get In Touch</span>
      <h1 class="main-hero-title font-weight-bold mb-3">We'd Love to Hear From You</h1>
      <p class="hero-subtitle mx-auto">
        Have questions about listing your business or exploring categories? Our team is standing by to help.
      </p>
    </div>

    <!-- Contact Split Card -->
    <div class="row justify-content-center">
      <div class="col-lg-10">
        <div class="contact-card-container overflow-hidden">
          <div class="row m-0 h-100">
            
            <!-- Contact Info Panel (Left) -->
            <div class="col-md-5 p-5 d-flex flex-column justify-content-between contact-info-panel text-white">
              <div class="info-overlay"></div>
              
              <div class="relative z-10">
                <h3 class="font-weight-bold text-white mb-4">Contact Information</h3>
                <p class="text-white-80 mb-5">
                  Reach out to us directly or fill out the form. We'll get back to you within 24 hours.
                </p>
                
                <div class="d-flex align-items-start mb-4">
                  <div class="info-icon-box bg-white-10 text-white mr-3">
                    <fa-icon [icon]="faEnvelope"></fa-icon>
                  </div>
                  <div>
                    <h6 class="text-white-50 m-0 font-weight-bold uppercase small tracking-wider">Email Us</h6>
                    <a href="mailto:info@advibe.co.za" class="text-white text-decoration-none font-weight-bold">info@advibe.co.za</a>
                  </div>
                </div>

                <div class="d-flex align-items-start mb-4">
                  <div class="info-icon-box bg-white-10 text-white mr-3">
                    <fa-icon [icon]="faPhone"></fa-icon>
                  </div>
                  <div>
                    <h6 class="text-white-50 m-0 font-weight-bold uppercase small tracking-wider">Call Us</h6>
                    <span class="text-white font-weight-bold">+27 (0) 74 311 1427</span>
                  </div>
                </div>

                <div class="d-flex align-items-start mb-4">
                  <div class="info-icon-box bg-white-10 text-white mr-3">
                    <fa-icon [icon]="faMapMarker"></fa-icon>
                  </div>
                  <div>
                    <h6 class="text-white-50 m-0 font-weight-bold uppercase small tracking-wider">Location</h6>
                    <span class="text-white font-weight-bold">Johannesburg, South Africa</span>
                  </div>
                </div>
              </div>
              
              <!-- Brand Logo/Icon -->
              <div class="relative z-10 text-center mt-5">
                <img class="img-fluid brand-icon-img opacity-80" src="assets/icon.png" alt="ADVIBE Icon" style="max-height: 48px;" />
              </div>
            </div>

            <!-- Form Panel (Right) -->
            <div class="col-md-7 p-5 bg-white d-flex flex-column justify-content-center">
              <h3 class="font-weight-bold mb-4" style="color: var(--text-main);">Send us a Message</h3>
              
              <mat-progress-bar
                [mode]="loading ? 'indeterminate' : 'determinate'"
                [value]="0"
                class="mb-4"
                style="height: 4px; border-radius: 2px;">
              </mat-progress-bar>
              
              <form *ngIf="FormData" [formGroup]="FormData" (submit)="onSubmit()">
                <div class="row">
                  <div class="col-12">
                    <mat-form-field appearance="outline" class="w-100 mb-3">
                      <mat-label>Name</mat-label>
                      <input matInput placeholder="Your full name" name="name" formControlName="name">
                    </mat-form-field>
                  </div>
                  <div class="col-12">
                    <mat-form-field appearance="outline" class="w-100 mb-3">
                      <mat-label>Email Address</mat-label>
                      <input type="email" matInput placeholder="name@domain.com" name="email" formControlName="email">
                    </mat-form-field>
                  </div>
                  <div class="col-12">
                    <mat-form-field appearance="outline" class="w-100 mb-3">
                      <mat-label>Phone Number</mat-label>
                      <input matInput placeholder="e.g. +27 82 123 4567" name="number" formControlName="number">
                    </mat-form-field>
                  </div>
                  <div class="col-12">
                    <mat-form-field appearance="outline" class="w-100 mb-3">
                      <mat-label>Your Message</mat-label>
                      <textarea matInput rows="4" placeholder="How can we assist you?" message="message" formControlName="message"></textarea>
                    </mat-form-field>
                  </div>
                </div>

                <div class="d-flex align-items-center justify-content-end mt-3">
                  <button mat-flat-button color="primary" [disabled]="loading" type="submit" class="submit-btn font-weight-bold text-white px-5 py-3 rounded-pill bg-primary" style="box-shadow: 0 4px 12px rgba(177, 135, 49, 0.3);">
                    {{ loading ? 'Sending...' : 'Send Message' }}
                  </button>
                </div>
              </form>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    
  </div>
</div>
